/* eslint-disable react-hooks/exhaustive-deps */
import { useState, forwardRef, useEffect, useCallback, useMemo } from "react";

// ** MUI Imports
import Badge from "@mui/material/Badge";
import MuiAvatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker'
import { convertToUnixTimestamp } from "../../functions/isoToNumberFormate";

// ** Icon Imports
import Icon from "../../../@core/components/icon";

import CustomAvatar from "../../../@core/components/mui/avatar";
// import OptionsMenu from 'src/@core/components/option-menu'
import ChatLog from "./ChatLog";
import { Button, Chip, InputAdornment, MenuItem } from "@mui/material";
import CustomTextField from "../../../@core/components/mui/text-field";
import format from "date-fns/format";

import Spinner from "../../../@core/components/spinner";
import { copyToClipboard } from "../../functions/clipboardUtils";

// ** Styled Components
const ChatWrapperStartChat = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  height: "100%",
  display: "flex",
  borderRadius: 1,
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  backgroundColor: theme.palette.action.hover,
}));

const ChatContent = (props) => {
  // ** Props
  const {
    hidden,
    mdAbove,
    handleLeftSidebarToggle,
    handleUserProfileRightSidebarToggle,
    data,
    type,
    selectedCompanyName,
    handleChanges,
    statusTab,
    selectedId,
    downloadData,
    isLoading,
    setLoadingById,
    heading,
    selectedTruesellerAccount,
    setIsShowFullDate,
    isShowFullDate
  } = props;
  const [startDateRange, setStartDateRange] = useState(null);
  const [endDateRange, setEndDateRange] = useState(null);
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("order_id");
  const [userData, setUserData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage] = useState(50);
  const [showPagination, setShowPagination] = useState(true);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const fetchRecordById = useCallback(() => {
    setLoadingById(true);
    handleChanges(
      { statusTab, type, gstId: selectedId, size: perPage, page: page - 1 },
      selectedCompanyName,
      selectedTruesellerAccount
    );
  }, [statusTab, type, selectedId, perPage, page, selectedCompanyName, selectedTruesellerAccount, handleChanges, setLoadingById]);


  useEffect(() => {
    if (selectedCompanyName) {
      fetchRecordById();
    } else {
      setIsShowFullDate(true)
      setStartDateRange(null)
      setEndDateRange(null)
    }
  }, [page]);

  const CustomInput = forwardRef((props, ref) => {
    // Format start and end dates
    const startDateFormatted = props.start
      ? format(props.start, "MM/dd/yyyy")
      : "";
    const endDateFormatted = props.end ? format(props.end, "MM/dd/yyyy") : "";

    // Handle empty value with placeholder
    const value =
      startDateFormatted || endDateFormatted
        ? `${startDateFormatted}${endDateFormatted ? " - " + endDateFormatted : ""}`
        : ""; // Placeholder text

    return (
      <div className="relative flex items-center">
        <CustomTextField
          inputRef={ref}
          label={props.label || ""}
          {...props}
          value={value}
          placeholder="Start Date - End Date"
        />
      </div>
    );
  });

  const resetData = useCallback(() => {
    setUserData(data.content);
  }, [data]);

  // default set
  useEffect(() => {
    if (data && data.content) {
      resetData();
      setTotalPage(data.totalPages);
    }
  }, [data, resetData]);

  const submitQuery = (data) => {
    if (data) {
      clearFilter(selectedId, selectedCompanyName, statusTab);
    } else {
      let filterData = userData;
      let payload = { searchBy };

      if (searchBy && search) {
        payload["search"] = search;
      }

      if (startDateRange && endDateRange) {
        const { startTimestamp, endTimestamp } = convertToUnixTimestamp(startDateRange, endDateRange)
        payload["startDate"] = startTimestamp
        payload["endDate"] = endTimestamp
      }
      handleChanges(
        {
          statusTab,
          type,
          gstId: selectedId,
          size: perPage,
          page: page - 1,
          ...payload,
        },
        selectedCompanyName
      );

      setShowPagination(false);
      setUserData(filterData); // Set the filtered data
    }
  };

  const clearFilter = useCallback((gstid, companyName, status) => {
    handleChanges(
      { statusTab: status, type, gstId: gstid, size: perPage, page: 0 },
      companyName
    );
    setPage(1); // Reset to page 1 when clearing
    setShowPagination(true);
    setSearchBy("order_id");
    setSearch("");
    setStartDateRange(null);
    setEndDateRange(null);
  }, [handleChanges, type, perPage]);

  const handleOnChange = useCallback((dates) => {
    const [start, end] = dates;
    setStartDateRange(start);
    setEndDateRange(end);
  }, []);

  useEffect(() => {
    return renderNotSelectedContent;
  }, [statusTab]);

  const renderChatLog = useMemo(() => {

    return <ChatLog
      type={type}
      data={userData}
      totalPage={totalPage}
      handlePageChange={handlePageChange}
      page={page}
      showPagination={showPagination}
      downloadData={downloadData}
      statusTab={statusTab}
      selectedCompanyName={selectedCompanyName}
      heading={heading}
    />

  }, [type, userData, totalPage, page, showPagination, statusTab, data]);

  const renderNotSelectedContent = useCallback(() => {
    return (
      <ChatWrapperStartChat
        sx={{
          ...(mdAbove
            ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }
            : {}),
        }}
      >
        {/* <Box> */}

        {/* <Box
            sx={{
              px: 5,
              py: 2.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "background.paper",
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            {mdAbove ? null : (
              <IconButton onClick={handleLeftSidebarToggle} sx={{ mr: 2 }}>
                <Icon icon="tabler:menu-2" />
              </IconButton>
            )}
          </Box> */}
        <Box style={{ display: 'flex', justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
          <MuiAvatar
            sx={{
              mb: 6,
              pt: 8,
              pb: 7,
              px: 7.5,
              width: 110,
              height: 110,
              boxShadow: 3,
              backgroundColor: "background.paper",
              cursor: 'pointer'
            }}
            onClick={handleLeftSidebarToggle}
          >
            <Icon icon="tabler:message" fontSize="3.125rem" />
          </MuiAvatar>
          <Box
            onClick={handleLeftSidebarToggle}
            sx={{
              py: 2,
              px: 6,
              boxShadow: 3,
              borderRadius: 5,
              backgroundColor: "background.paper",
              cursor: "pointer",
            }}
          >
            <Typography
              sx={{ fontWeight: 500, fontSize: "1.125rem", lineHeight: "normal" }}
            >
              Select Account
            </Typography>
          </Box>
        </Box>
        {/* </Box> */}
      </ChatWrapperStartChat>
    );
  }, []);

  // const renderContent = useCallback(() => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <div style={{ width: "100%" }}>
          <Spinner height={"100%"} bgColor={"#f7f7f7"} />
        </div>
      );
    } else {
      if (userData.length === 0) {
        return (
          <ChatWrapperStartChat
            sx={{
              ...(mdAbove
                ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }
                : {}),
            }}
          >
            <MuiAvatar
              sx={{
                mb: 6,
                pt: 8,
                pb: 7,
                px: 7.5,
                width: 110,
                height: 110,
                boxShadow: 3,
                backgroundColor: "background.paper",
                cursor: mdAbove ? "default" : "pointer",
              }}
              onClick={handleLeftSidebarToggle}
            >
              <Icon icon="tabler:message" fontSize="3.125rem" />
            </MuiAvatar>
            <Box
              sx={{
                py: 2,
                px: 6,
                boxShadow: 3,
                borderRadius: 5,
                backgroundColor: "background.paper",
                cursor: mdAbove ? "default" : "pointer",
              }}
              onClick={handleLeftSidebarToggle}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "1.125rem",
                  lineHeight: "normal",
                }}
              >
                {selectedCompanyName ? ' Select Another Account' : 'No Record Found'}
              </Typography>
            </Box>
          </ChatWrapperStartChat>
        );
      } else {
        return (
          <Box
            sx={{
              width: 0,
              flexGrow: 1,
              minHeight: "85vh",
              maxHeight: "87vh",
              backgroundColor: "action.hover",
            }}
          >
            <Box
              sx={{
                px: { xs: 1, sm: 2, md: 3 },
                py: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "background.paper",
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", minWidth: '300px' }}>
                {mdAbove ? null : (
                  <IconButton onClick={handleLeftSidebarToggle} sx={{ mr: 2 }}>
                    <Icon icon="tabler:menu-2" />
                  </IconButton>
                )}
                <Box
                  onClick={handleUserProfileRightSidebarToggle}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    height: "38px",
                  }}
                >
                  {mdAbove ?
                    <Badge
                      overlap="circular"
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      sx={{ mr: 3 }}
                      badgeContent={
                        <Box
                          component="span"
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            boxShadow: (theme) =>
                              `0 0 0 2px ${theme.palette.background.paper}`,
                          }}
                        />
                      }
                    >
                      <CustomAvatar
                        skin="light"
                        sx={{
                          width: 28,
                          height: 28,
                          fontSize: (theme) => theme.typography.body1.fontSize,
                        }}
                      >
                        {selectedCompanyName &&
                          selectedCompanyName.charAt(0).toUpperCase()}
                      </CustomAvatar>
                    </Badge>
                    : null}
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="body2">{selectedCompanyName}
                      {/* <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(selectedTruesellerAccount, "")} /> */}

                    </Typography>
                    <Box display={"flex"} alignItems={"center"} gap={2}>
                      <Typography variant='body2'>{selectedTruesellerAccount}
                        <Icon icon="iconamoon:copy-duotone" width="14" height="14" style={{ color: '#7367f0', marginLeft: "5px" }} onClick={() => copyToClipboard(selectedTruesellerAccount, "")} />
                      </Typography>

                    </Box>
                    <Box display={"flex"} alignItems={"center"} gap={2}>
                      <Chip label={heading} size="small" sx={{
                        background: "#fef4dc",
                        '& .MuiChip-label': {
                          fontSize: '13px',
                          color: '#cf8717',
                          padding: { xs: '5px 10px', sm: '5px 10px', md: '5px 15px' },
                          fontWeight: "700"
                        }
                      }} />
                      <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(heading, "")} />

                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                {hidden ?
                  isShowFullDate ?
                    <IconButton aria-label="delete" onClick={() => setIsShowFullDate(false)}>
                      <Icon icon="bx:calendar" width="24" height="24" /> </IconButton>
                    :
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginRight: "16px" }}>
                      <DatePicker
                        selectsRange
                        monthsShown={2}
                        endDate={endDateRange}
                        selected={startDateRange}
                        startDate={startDateRange}
                        shouldCloseOnSelect={false}
                        placeholder="select Date"
                        id='date-range-picker-months'
                        onChange={handleOnChange}
                        customInput={<CustomInput end={endDateRange} start={startDateRange} />}
                      />
                    </div>

                  :
                  <Box sx={{
                    display: "flex", flexDirection: "row", alignItems: "center", marginRight: { xs: '4px', sm: "8px", lg: "16px" }
                  }}>
                    <DatePicker
                      selectsRange
                      monthsShown={2}
                      endDate={endDateRange}
                      selected={startDateRange}
                      startDate={startDateRange}
                      shouldCloseOnSelect={false}
                      id='date-range-picker-months'
                      onChange={handleOnChange}
                      customInput={<CustomInput end={endDateRange} start={startDateRange} />}
                    />
                  </Box>
                }
                <Box>
                  <CustomTextField
                    fullWidth
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search By Order..."
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        submitQuery(); // Call your function here
                      }
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "30px !important",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          sx={{ color: "text.secondary" }}
                        >
                          <Icon fontSize="1.25rem" icon="tabler:search" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                {search || (startDateRange && endDateRange) ? (
                  <>
                    <Button
                      variant="contained"
                      sx={{ marginLeft: "8px" }}
                      onClick={() => submitQuery()}
                    >
                      Filter
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ marginLeft: "8px" }}
                      color="secondary"
                      onClick={() => submitQuery("clear")}
                    >
                      Clear
                    </Button>
                  </>
                ) : (
                  ""
                )}
              </Box>
            </Box>
            {renderChatLog}
          </Box>
        );
      }
    }
    // }, []);
  };

  return selectedCompanyName ? renderContent() : renderNotSelectedContent();
};

export default ChatContent;
